import { parseJwt } from '@/core/utils/jwtUtils';
import { restoreState } from '@/modules/auth/redux/authSlice';
import { store } from '@/store/store';

export const initializeAuth = () => {
  const authState = localStorage.getItem('authState');
  if (authState) {
    try {
      const parsedAuthState = JSON.parse(authState);
      if (parsedAuthState?.accessToken) {
        // Optionally verify token expiration
        const decodedToken = parseJwt(parsedAuthState.accessToken);
        const currentTime = Date.now() / 1000;

        if (decodedToken && decodedToken.exp && decodedToken.exp > currentTime) {
          // Token is valid, dispatch to Redux store
          store.dispatch(
            restoreState({
              ...parsedAuthState,
              isAuthenticated: true,
            })
          );
          return true;
        }
      }
    } catch (error) {
      void error;
    }
  }
  return false;
};
